export const testimonials = [
  {
    text: "Scan to BIM Service Company is focused and dedicated to producing their best work at all times. They are fantastic problem-solvers, especially in difficult situations. I recommend them to anyone.",
    authorName: "Sunny Tam",
    authorTitle: "Studio 02 Inc.",
    imgSrc: "/img/testimonials/testimonial1.png",
    videoEmbedUrl: "https://www.youtube-nocookie.com/embed/WxEXecSFaxg",
  },
  {
    text: "Partnering with Scan to BIM Service Company was an incredible experience. Their expertise in BIM modeling and commitment to our residential project truly aligned with our goals.",
    authorName: "Watson",
    authorTitle: "Watson Drafting Solution",
    imgSrc: "/img/testimonials/testimonial2.png",
    videoEmbedUrl: "https://www.youtube-nocookie.com/embed/Dw3tTpIp-sU",
  },
  {
    text: "Thanks to Scan to BIM Service Company for their brilliant work. The process was professional and seamless, and the final result surpassed our expectations. We highly recommend them to anyone looking for a quality job at a reasonable price.",
    authorName: "Nick Lios",
    authorTitle: "Lios Design Studio, LLC",
    imgSrc: "/img/testimonials/testimonial3.png",
    videoEmbedUrl: "https://www.youtube-nocookie.com/embed/Q0JHeqAlga4?start=17",
  }
];
